import { Navigate, Outlet, useRoutes } from "react-router-dom";
import AuthForm from "./Pages/AuthForm/AuthForm";
import { homeRouteObject } from "./Pages/Home/HomeRouteObject";
import { PageLoadIndicator } from "@siba/components";
import { Suspense } from "react";
import SalvageList from "./Pages/Home/Salvage/SalvageList";
import UserLoginForm from "./Pages/Home/Salvage/UserLoginForm";
import BidList from "./Pages/Home/Salvage/BidList";
import BidderRegistrationForm from "./Pages/Home/Salvage/BidderRegistrationForm";
/***
 * Application route definition using useRoutes hook.
 */
export default function AppRouter() {
    let element = useRoutes([
        {
            element: <AuthForm />,
            children: [
                { path: "/", element: <Navigate to="/Salvage" /> },
                { path: "/Login", element: <UserLoginForm /> },
                { path: "/Salvage", element: <SalvageList /> },
                { path: "/Bids", element: <BidList /> },
                { path: "/Register", element: <BidderRegistrationForm /> },
                
            ]
        },
        {
            element: (
                <Suspense fallback={<PageLoadIndicator />}>
                    <Outlet />
                </Suspense>
            ),
            children: [homeRouteObject]
        }
    ]);

    return element;
}
